"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ActorRdfDereference_1 = require("./ActorRdfDereference");
/**
 * A base actor for dereferencing URLs to quad streams.
 *
 * Actor types:
 * * Input:  IActionRdfDereference:      A URL.
 * * Test:   <none>
 * * Output: IActorRdfDereferenceOutput: A quad stream.
 *
 * @see IActionRdfDereference
 * @see IActorRdfDereferenceOutput
 */


var ActorRdfDereferenceMediaMappings =
/*#__PURE__*/
function (_ActorRdfDereference_) {
  _inherits(ActorRdfDereferenceMediaMappings, _ActorRdfDereference_);

  function ActorRdfDereferenceMediaMappings(args) {
    _classCallCheck(this, ActorRdfDereferenceMediaMappings);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorRdfDereferenceMediaMappings).call(this, args));
  }
  /**
   * Get the media type based on the extension of the given path,
   * which can be an URL or file path.
   * @param {string} path A path.
   * @return {string} A media type or the empty string.
   */


  _createClass(ActorRdfDereferenceMediaMappings, [{
    key: "getMediaTypeFromExtension",
    value: function getMediaTypeFromExtension(path) {
      var dotIndex = path.lastIndexOf('.');

      if (dotIndex >= 0) {
        var ext = path.substr(dotIndex); // ignore dot

        return this.mediaMappings[ext.substring(1)] || '';
      }

      return '';
    }
  }]);

  return ActorRdfDereferenceMediaMappings;
}(ActorRdfDereference_1.ActorRdfDereference);

exports.ActorRdfDereferenceMediaMappings = ActorRdfDereferenceMediaMappings;